export default "__VITE_ASSET__07ba18a2__"